import { CategoriesSearchResponse } from "../../../../types";
import { fetchApiData } from "../../../../utils/fetchApiData";

export default (): Promise<CategoriesSearchResponse> => {
  return fetchApiData({ url: `/api/user/categories/` });
};
